/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef } from 'react';
import Flink from '~/components/shared/flink'
import { useSwipeable } from 'react-swipeable'
import { useTheme } from '~/contexts/ThemeContext'
import { altText, jnstyls, imgSize } from '~/utils/helpers'
// import ImgGridAct from '~/helpers/img-grid'

import VideoBg from '~/components/video/bg'
import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/shared/img_grid.module.scss";

const TileImages = ({ 
  media, handle, title, wr_class, gender, linked, tile_ind, 
  toggleFlats, onHandleSelect=false, gaInteract=false, ids={}
}) => {
  const { isMobile, isTouches } = useTheme()

  const [isOff, setIsOff] = useState(false)
  const [changeSrc, setChangeSrc] = useState(false)
  const [firstLoad, setFirstLoad] = useState(true)

  const total = media && (media.length - 1)

  const gridRef = useRef(null)
  const firstRef = useRef(null)

  const checkShow = (hover=false) => { 
    let firstimg
    let hoverimg
    const has_new = media.find(x => !!x.face || !!x.hover)
    if (has_new) {
      firstimg = media.findIndex( x => x.face)
      hoverimg = media.findIndex( x => x.hover)
      if (hoverimg === -1) {
        hoverimg = media.filter((x,index) => index !== firstimg)[0] || null
        hoverimg = media.findIndex(x => x === hoverimg)
      }
    } else {
      const def_flat = !toggleFlats ? 'flat' : toggleFlats
      const flat_ind = media.findIndex( x => !!x.flat)
      let notflat_ind = media.findIndex( x => x.alt && x.alt.toLowerCase().includes('model'))
      if (notflat_ind < 0) notflat_ind = media.findIndex( x => !x.flat )
      const nextnot_ind = media.findIndex( (x, index) => index !== notflat_ind && !x.flat )

      firstimg = 0
      hoverimg = media.length > 1 ? 1 : 0

      if ( media.length > 1 && def_flat === 'flat') {
        firstimg = flat_ind >= 0 ? flat_ind : notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 && notflat_ind >= 0 ? notflat_ind : nextnot_ind
      }
      if ( media.length > 1 && def_flat !== 'flat') {
        firstimg = notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 ? flat_ind : nextnot_ind >= 0 ? nextnot_ind : 1
      }
      if (gender === 'u' && media.length > 1) {
        firstimg = flat_ind >= 0 ? flat_ind : notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 && notflat_ind >= 0 ? notflat_ind : nextnot_ind
      }
      if (gender === 'w' && media.length > 0 && media[0].type === 'VIDEO') {
        firstimg = 0
        hoverimg = 1
      }
    }

    return hover ? hoverimg : firstimg
  }

  const handleMouseEnter = (entering=true) => {
    if (isOff || media.length < 2) return
    setCurrShow(checkShow(entering))
    setChangeSrc(true)
  };

  const [currShow, setCurrShow] = useState(checkShow())
  const [dot, setDot] = useState(checkShow())

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches) return
    },
    onSwipedLeft: (e) => {
      if (!isTouches ) return
      img_forw()
    },
    onSwipedRight: (e) => {
      if (!isTouches) return
      img_back()
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  });

  const img_forw = () => {
    setIsOff(true)
    const new_pos = (currShow + 1) > total ? 0 : currShow + 1 
    setCurrShow(new_pos)
    setDot(new_pos)
    if (gaInteract) gaInteract('image grid swipe') 
  }

  const img_back = () => {
    setIsOff(true)
    const new_pos = currShow - 1 < 0 ? total : currShow - 1 
    setCurrShow(new_pos)
    setDot(new_pos)
    if (gaInteract) gaInteract('image grid swipe') 
  }

  const handleClick = (e) => {
    onHandleSelect()
  }

  const handleShow = (index) => {
    setCurrShow(index)
    setIsOff(true)
  }

  useEffect(() => {
    setFirstLoad(false)
    
    setTimeout(() => {
      if (firstRef && firstRef.current) firstRef.current.setAttribute('src', firstRef.current.getAttribute('data-src'))
    }, 400)
    
  }, []);

  useEffect(() => {
    const show = checkShow()
    setCurrShow( show )
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleFlats]);

  useEffect(() => {
    if ( !changeSrc || !gridRef.current ) return
    
    gridRef.current.querySelectorAll('img').forEach( x => {  
      x.setAttribute('src', x.getAttribute('data-src'))
    })
  }, [changeSrc]);

  const content = (
    <>
      {media.map( (item, index) => {
        const is_show = index === currShow 
        const is_hov = index === checkShow(true) 

        let css = {
          zIndex: is_show ? '2' : '1',
          opacity: is_show ? '1' : '0'
        }

        switch (item.type) {
          case 'IMAGE':

            return (
              <img 
                key={`${handle}imggrid_${index}`}
                src={(changeSrc || is_show || is_hov) ? imgSize(item.src,700) : undefined }
                data-src={imgSize(item.src,700)}
                alt={altText(item.alt, title)}
                className={jnstyls([styles.grid_img,`img_${index}`,is_show ? styles.show : '',is_hov ? 'foo' : ''])} 
                style={css}
                ref={is_show ? firstRef : undefined}
                width="400" 
                height="532" 
                loading={index < 6 ? undefined : "lazy"}
                decode="async"
              />
            );
          case 'VIDEO':
            const options = {
              autoplay: true,
              controls: false,
              children: ['mediaLoader', 'posterImage'],
              setPlaysinline: true,
              playsinline: true,
              handle: handle,
              poster: imgSize(item.src,700),
              muted: true,
              loop: true,
              sources: item.sources.filter(x => x.mimeType !== 'application/x-mpegURL').map((x) => {
                return {src: x.url, type: x.mimeType}
              })
            }

            return (
              <div 
                key={`${handle}imggrid_${index}`}
                className={jnstyls([styles.gallvid,styles.grid_img,`img_${index}`,is_show ? styles.show : ''])}
                style={{
                  zIndex: is_show ? '2' : '1',
                  opacity: is_show ? '1' : '0'
                }}
                width="400" 
                height="532" 
              >
                <VideoBg 
                  options={options}
                  vidclasses={styles.tile_vid}
                  key={`${tile_ind}_{index}`}
                  off={!(changeSrc || index < 2 || index === currShow)}
                />
              </div>
            );
          default:
            return ''
        }
      })}
    </>
  )

  return (
    <>
      {linked ? (
        <Flink
          href={`/products/${handle}`}
          className={jnstyls([styles.img_grid, styles.tile_grid, isOff ? styles.hovoff : ''])}
          aria-label={title}
          {...(!isMobile ? { 
            onMouseEnter: (e)=>{handleMouseEnter()}, 
            onMouseLeave: (e)=>{handleMouseEnter(false)} 
          } : {})}
          onClick={handleClick}
          ref={gridRef}
          {...swipers}
        >
          {content}
        </Flink>
      ) : (
        <div 
          className={`${styles.img_grid} ${styles.hovoff}`}
          {...(!isMobile ? { 
            onMouseEnter: (e)=>{handleMouseEnter()}, 
            onMouseLeave: (e)=>{handleMouseEnter(false)} 
          } : {})}
          ref={gridRef}
          {...swipers}
        >
          {content}
        </div>
      )}

      {(!isMobile && media.length > 2) && (
        <>
          <button 
            type="button"
            className={[aria_btn, styles.arrows].join(' ')}
            onClick={(e)=> img_back()}
            arr=''
            aria-label='Show previous image'
            aria-hidden={dot === 0 ? 'true' : 'false'}
          >
            <IconChevLeft />
          </button>
          <button 
            type="button"
            className={jnstyls([aria_btn, styles.arrows, styles.arrow_right])}
            onClick={(e)=> img_forw()}
            arr=''
            aria-label='Show next image'
            aria-hidden={'false'}
          >
            <IconChevRight />
          </button>
        </>
      )}
      {isMobile && media.length > 1 && (
        <div className={styles.indicate}>
          {media.map((x,index) => 
            <div key={`dot${index}`} className={jnstyls([styles.ind_dot, dot === index ? styles.curr : ''])} />
          )}
        </div>
      )}
    </>
  )
}

export default TileImages




